import { getLoginActivityApi, getReportsListApi } from 'Constants';
import { Context } from 'Context/Context';
import React, { useContext, useEffect, useState } from 'react'
import moment from 'moment';
import { AdminPage, RangeBar, Panel, rangeLabelOf } from './AdminAnalyticsUI';
import TimeframeHeader from './TimeframeHeader';
import AnalyticReportCard from './AnalyticReportCard';
import ReportsAnalyticsTable from './ReportsAnalyticsTable';
import ReportsReasonGraph from './ReportsReasonGraph';

function ReportsAnalytics({setActivePanel, activePanel}) {
    const {makeApiCallFunc} = useContext(Context);
    const [reportData, setReportData] = useState(false);
    const [frame, setFrame] = useState("month");

    const [xAxisValues, setXAxisValues] = useState([]);
    const [values, setValues] = useState([]);
    const [totalCount, setTotalCount] = useState();

    const [loadUserActivity, setLoadUserActivity] = useState(true);

    const [dateRange, setDateRange] = useState([
      {
        endDate: new Date(Date.now()),
        startDate: new Date(Date.now() -  30 * 24 * 60 * 60 * 1000),
        key: 'selection'
      }
      ]);
      const isMoreThanNDays = (days) => {
        const date1 = moment(dateRange[0]?.startDate);
        const date2 = moment( dateRange[0]?.endDate);
        const differenceInDays = date2.diff(date1, 'days');
    
        // Check if the difference is more than 60 days
        const moreThanNDaysApart = differenceInDays > days;
        return moreThanNDaysApart;
      }
      const getCasesReported = (data) => {
            let noOfCasesReported = 0; 
            let casesArr = [];

            data?.reported?.map((r) => 
            {
                if(!casesArr.includes(r.caseId._id))
                {
                    casesArr.push(r.caseId._id);
                    noOfCasesReported++;
                }
                return noOfCasesReported;
            })
            return noOfCasesReported;
      }
      const getCasesDeleted = (data) => {
        let casesDeletedNo = 0;
        let countedCases = [];
        data?.reported?.forEach((r) => {
        if (!countedCases.includes(r.caseId._id)) {
            let countCaseId = 0;
            data?.reported?.forEach((t) => {
                if (t.caseId._id === r.caseId._id) {
                    countCaseId++;
                }
          });
        if (countCaseId > 2) {
            casesDeletedNo++;
        }
        countedCases.push(r.caseId._id);
    }
});
console.log(casesDeletedNo);
return casesDeletedNo;
      }
    useEffect(() => {
        makeApiCallFunc(getReportsListApi,
                {
                    startTime : dateRange?.[0]?.startDate,
                    endTime : dateRange?.[0]?.endDate
                },
            ({data})=> {
              setReportData(data);
              getCountTotal(data);
            },
            (data) => console.log(data) 
            )
    },[loadUserActivity]);
    const getCountTotal = (data) => {
      const dates = [];
      let values = {
        "created" : [],
        "reported" : [],
        "casesReported" : [],
        "deleted" : []
      };
      let currentDate = moment(dateRange[0]?.startDate);
      const finalDate = moment(dateRange[0]?.endDate);
      const count = {
        "created": data?.created?.length,
        "reported" : data?.reported?.length,
        "casesReported" : getCasesReported(data),
        "deleted" : getCasesDeleted(data)
      }
      if(isMoreThanNDays(365))
      {
          while (currentDate <= finalDate){
            dates.push(moment(currentDate).format("YYYY"));
            const addedValues = addUpValues(moment(currentDate).startOf("year"), moment(currentDate).add(1, "year").startOf("year"), data);
            values.created.push(addedValues?.created);
            values.reported.push(addedValues?.reported);
            currentDate = moment(currentDate).add(1, "year");
          }
      }
      else if(isMoreThanNDays(30))
      {
          while (currentDate <= finalDate){
            dates.push(moment(currentDate).format("MMM YYYY"));
            const addedValues = addUpValues(moment(currentDate).startOf('month'), moment(currentDate).add(1, "month").startOf('month'), data);
            values.created.push(addedValues?.created);
            values.reported.push(addedValues?.reported);
            currentDate = moment(currentDate).add(1, "month");
          }
      }
      else
      {
        while (currentDate <= finalDate) {
          dates.push(moment(currentDate).format("MM-DD-YYYY"));
          const valueseOnGivenDate = getValues(currentDate, data);

          values.created.push(valueseOnGivenDate?.totalcreatedLoginCount);
          values.reported.push(valueseOnGivenDate?.totalreportedLoginCount);
         // values.casesReported.push(valueseOnGivenDate?.totalCasesReported);
         currentDate = moment(currentDate).add(1, "days");
        }
      }
      setXAxisValues(dates);
      setValues(values);
      setTotalCount(count);
      return dates;
    }
    const addUpValues = (startD, endD, data) => 
    {
      const returnObj = {
        created: 0,
        reported: 0,
        casesReported:0
      }
      while (startD < endD) {
        const valueseOnGivenDate = getValues(startD, data);

        returnObj.created = returnObj.created + valueseOnGivenDate?.totalcreatedLoginCount;
        returnObj.reported = returnObj.reported + valueseOnGivenDate?.totalreportedLoginCount;
       // returnObj.casesReported = returnObj.casesReported + valueseOnGivenDate?.totalCasesReported;

        startD = moment(startD).add(1, "days");
      }
      return returnObj;
    }
    const getValues = (currentDate, data) => {
      
      var itemToRe = {
        totalcreatedLoginCount: 0,
        totalreportedLoginCount: 0,
      };
      const date2 = moment(currentDate);
      data?.created?.map((i) => {
        const date1 = moment(i?.created_at);
        const areDatesSame = date1.isSame(date2, "day"); // Change "day" to "date" if you want to compare the dates down to the millisecond
        if(areDatesSame)
        { 
            itemToRe.totalcreatedLoginCount++;
        }
        return itemToRe
      })
      data?.reported?.map((i)=> {
        const date1 = moment(i?.updated_at);
        const areDatesSame = date1.isSame(date2, "day"); // Change "day" to "date" if you want to compare the dates down to the millisecond
        if(areDatesSame)
        { 
            itemToRe.totalreportedLoginCount++;
        }
        return itemToRe
      })
     console.log(itemToRe)
    return itemToRe;
  
  }
    const isSingleDay = () => {
      const date1 = moment(dateRange[0]?.startDate);
      const date2 = moment( dateRange[0]?.endDate);
  
      // Compare if the two dates are the same
      const areDatesSame = date1.isSame(date2, "date"); // Change "day" to "date" if you want to compare the dates down to the millisecond
      return areDatesSame
    }
  return (
    <AdminPage setActivePanel={setActivePanel} activePanel={activePanel} title="Reports" subtitle="Cases flagged by professionals, and why.">
      <RangeBar dateRange={dateRange}>
        <TimeframeHeader className='flex items-center' setLoadCaseAnalytics={setLoadUserActivity} frame={frame} setFrame={setFrame} setDateRange={setDateRange} dateRange={dateRange}/>
      </RangeBar>
      <AnalyticReportCard
        totalCount={totalCount}
        xAxisValues={xAxisValues}
        values={values}
        rangeLabel={rangeLabelOf(dateRange)}
      />
      <div className='grid grid-cols-1 lg:grid-cols-2' style={{ gap: '22px', marginTop: '28px' }}>
        <Panel title="Reported case types">
          <ReportsAnalyticsTable data={reportData}/>
        </Panel>
        <Panel title="Reasons for reporting">
          <ReportsReasonGraph data={reportData}/>
        </Panel>
      </div>
    </AdminPage>
  )
}

export default ReportsAnalytics